import { useState } from 'react';
import YesNoDialog from './YesNoDialog';

export const useYesNoDialog = (isNoButtonVisible: boolean) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dialogConfig, setDialogConfig] = useState<{
    title: string;
    message: string;
    yesText?: string;
    noText?: string;
    defaultButton?: 'yes' | 'no';
    dialogBgColor?: string;
    yesBgColor?: string;
    noBgColor?: string;
    yesTextColor?: string;
    noTextColor?: string;
  } | null>(null);
  const [resolver, setResolver] = useState<((result: boolean | undefined) => void) | null>(null);

  const confirm = (config: {
    title: string;
    message: string;
    yesText?: string;
    noText?: string;
    defaultButton?: 'yes' | 'no';
    dialogBgColor?: string;
    yesBgColor?: string;
    noBgColor?: string;
    yesTextColor?: string;
    noTextColor?: string;
  }): Promise<boolean | undefined> => {
    return new Promise((resolve) => {
      setDialogConfig(config);
      setResolver(() => resolve);
      setIsOpen(true);
    });
  };

  const handleYes = () => {
    setIsOpen(false);
    if (resolver) {
      resolver(true);
      setResolver(null);
    }
  };

  const handleNo = () => {
    setIsOpen(false);
    if (resolver) {
      resolver(false);
      setResolver(null);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    if (resolver) {
      resolver(undefined);
      setResolver(null);
    }
  };


  const dialog = (
    <YesNoDialog
      isOpen={isOpen}
      title={dialogConfig?.title || ""}
      message={dialogConfig?.message || ""}
      yesText={dialogConfig?.yesText || "Ja"}
      noText={dialogConfig?.noText || "Nein"}
      defaultButton={dialogConfig?.defaultButton || "yes"}
      dialogBgColor={dialogConfig?.dialogBgColor}
      yesBgColor={dialogConfig?.yesBgColor}
      noBgColor={dialogConfig?.noBgColor}
      yesTextColor={dialogConfig?.yesTextColor}
      noTextColor={dialogConfig?.noTextColor}
      noButtonVisible={isNoButtonVisible}
      onYes={handleYes}
      onNo={handleNo}
      onClose={handleClose}
    />
  );

  return {
    confirm,
    dialog,
  };
};